import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import { buildPricingCheckout } from '../../utils/pricingCatalog';

export default function usePricingCheckout({ successUrl, cancelUrl } = {}) {
  const { currentUser } = useAuth();
  const { t } = useTranslation('pricing');
  const [pendingPlan, setPendingPlan] = useState(null);
  const [errorKey, setErrorKey] = useState(null);
  const inFlight = useRef(false);

  const selectPlan = async (plan, productType, billingPeriod) => {
    if (inFlight.current) return;
    setErrorKey(null);
    if (!currentUser) {
      setErrorKey('messages.loginRequired');
      return;
    }
    let payload;
    try {
      payload = buildPricingCheckout({ plan, productType, billingPeriod,
        successUrl: successUrl || window.location.href,
        cancelUrl: cancelUrl || window.location.href });
    } catch {
      setErrorKey('messages.invalidConfig');
      return;
    }
    inFlight.current = true;
    setPendingPlan(plan.id);
    try {
      const checkout = httpsCallable(getFunctions(app), 'createCheckoutSessionUnified');
      const response = await checkout(payload);
      if (!response.data?.sessionUrl) throw new Error('checkout-no-url');
      window.location.assign(response.data.sessionUrl);
      // Keep controls locked until navigation to Checkout completes.
    } catch (error) {
      const code = error.code?.replace('functions/', '');
      setErrorKey(code === 'unauthenticated' ? 'messages.loginRequired' :
        code === 'invalid-argument' ? 'messages.invalidConfig' : 'messages.checkoutFailure');
      inFlight.current = false;
      setPendingPlan(null);
    }
  };
  return { selectPlan, pendingPlan, error: errorKey ? t(errorKey) : null };
}
